/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ hours: NonNullable<unknown> }} Notifications_Time_Hours_AgoInputs */

const en_notifications_time_hours_ago = /** @type {(inputs: Notifications_Time_Hours_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hours}h ago`)
};

const pl_notifications_time_hours_ago = /** @type {(inputs: Notifications_Time_Hours_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hours} godz. temu`)
};

/**
* | output |
* | --- |
* | "{hours}h ago" |
*
* @param {Notifications_Time_Hours_AgoInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const notifications_time_hours_ago = /** @type {((inputs: Notifications_Time_Hours_AgoInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Time_Hours_AgoInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_notifications_time_hours_ago(inputs)
	return en_notifications_time_hours_ago(inputs)
});